export default __webpack_public_path__ + "static/media/prashant kumar_fw10_167.640ca58c.pdf";